import { __awaiter } from "tslib";
import axios from "axios";
export function generateQueryParams(options) {
    const queryParams = Object.keys(options)
        .reduce((acc, key) => {
        if (key in options && options[key] !== undefined) {
            const value = options[key];
            if (typeof value === "boolean") {
                acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`);
            }
        }
        return acc;
    }, [])
        .join("&");
    return queryParams ? `?${queryParams}` : "";
}
export function getPasses(address, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const url = `${options.civicPassLookupEndpoint}/${address}${generateQueryParams(options)}`;
        const result = yield axios.get(url);
        return (_a = result.data[address]) === null || _a === void 0 ? void 0 : _a.passes;
    });
}
